<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import '@/style/css/index.css'
export default {
  name: 'App',
}
</script>

<style>
  #app{
    background-color: rgb(38,57,207);
    height: 100%;
    width: 100%;
  }
</style>
